import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import { GridRowModes, DataGridPro, GridToolbarContainer, GridActionsCellItem } from '@mui/x-data-grid-pro';
import { randomId } from '@mui/x-data-grid-generator';
import Tooltip from '@mui/material/Tooltip';
import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import DownloadIcon from '@mui/icons-material/Download';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import Chip from '@mui/material/Chip';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import { API_URL } from "../../../services/api-uri"
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css


function EditToolbar({ setFiles, setRowModesModel }) {

    const handleNewFile = async (e) => {
        if (!e.target.files) { return; }
        try {
            for (let file of e.target.files) {
                let b64 = await toBase64(file);

                let id = randomId();
                setFiles((oldRows) => [...oldRows, { id, name: file.name, type: file.type, size: (file.size / 1000000).toFixed(2), date: new Date(), data: b64 }]);
                setRowModesModel((oldModel) => ({
                    ...oldModel, [id]: { mode: GridRowModes.Edit, fieldToFocus: 'reference' },
                }));
            }
        } catch (error) {
            console.error(error);
            return;
        }
    }


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    return (
        <GridToolbarContainer>
            <Button component="label" endIcon={<AddIcon />}>
                NEW FILE
                <input type="file" hidden multiple maxFileSizeBytes={3 * 1024 * 1024} onChange={(e) => { handleNewFile(e) }} />
            </Button >
        </GridToolbarContainer>
    );
}

EditToolbar.propTypes = {
    setRowModesModel: PropTypes.func.isRequired,
    setFiles: PropTypes.func.isRequired,
};

export default function Files({ files, setFiles, profilePicture, passportPicture, booking_id, student }) {


    const downloadPicture = (passport) => {
        var link = document.createElement("a");
        link.download = passport == true ? `${student.name}_${student.lastname}_passport.png` : `${student.name}_${student.lastname}_profile.png`;
        link.href = passport == true ? passportPicture : profilePicture;
        document.body.appendChild(link);
        link.click();
    }
    const [rowModesModel, setRowModesModel] = React.useState({});

    const handleDeleteClick = (id) => () => {
        confirmAlert({
            message: 'Delete the selected file ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => setFiles(files.filter((row) => row.id !== id))
                },
                {
                    label: 'No'
                }
            ]
        });
    };



    const handleDownloadClick = (id) => () => {
        let file = files.filter((row) => row.id == id)[0];
        var link = document.createElement("a");
        link.download = file.name;
        link.href = file.path ? file.path : file.data;

        document.body.appendChild(link);
        link.click();
    };

    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            type: 'text',
            flex: 1,
            editable: false,
        },
        {
            field: 'size',
            headerName: 'Size (MB)',
            align: "center",
            type: 'number',
            editable: false,
        },
        {
            field: 'type',
            headerName: 'Type',
            align: "center",
            type: 'text',
            editable: false,
        },
        {
            field: 'date',
            headerName: 'Modified',
            type: 'date',
            width: 180,
            editable: false,
            align: "center",
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<DownloadIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleDownloadClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];

    return (
        <Box sx={{ height: 500, width: '100%' }} >
            {profilePicture ?
                <Chip
                    sx={{ m: 1 }}
                    label="Profile Picture"
                    onClick={() => { downloadPicture(false) }}
                    onDelete={() => { downloadPicture(false) }}
                    deleteIcon={<DownloadIcon />}
                    variant="contained"
                /> : <></>
            }
            {passportPicture ?
                <Chip
                    sx={{ m: 1 }}
                    label="Passport Picture"
                    onClick={() => { downloadPicture(true) }}
                    onDelete={() => { downloadPicture(true) }}
                    deleteIcon={<DownloadIcon />}
                    variant="contained"
                /> : <></>
            }
            <DataGridPro
                rows={files.map((p) => {
                    p.date = new Date(p.date);
                    return p;
                })}
                columns={columns}
                rowModesModel={rowModesModel}
                onRowModesModelChange={(newModel) => setRowModesModel(newModel)}

                components={{
                    Toolbar: EditToolbar,
                }}
                hideFooter
                componentsProps={{
                    toolbar: { setFiles, setRowModesModel },
                }}
                experimentalFeatures={{ newEditingApi: true }}
            />

        </Box>
    );
}